var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-grays-lighter rounded-s rounded-e w-full h-2 relative"},[_c('div',{staticClass:"absolute left-0 top-0 rounded-s rounded-e bg-primary h-2",style:({width: (_vm.percent + "%")})})])}
var staticRenderFns = []

export { render, staticRenderFns }